
import apiClient from "../../core/apiClient";
import { Family, FamilyCreateDTO, FamilyWithMembers } from "../../interfaces/DTO/crm/family";
import { BaseService } from "../BaseService";

const API_URL = "/families";

class FamilyService extends BaseService<Family> {
  constructor() {
    super(API_URL);
  }

  async createFamilyWithMembers(familyData: FamilyCreateDTO): Promise<FamilyWithMembers> {
    const response = await apiClient.post<FamilyWithMembers>(
      `${this.baseUrl}/create-family-with-members`,
      familyData
    );
    return response.data;
  }

  async hasActivePortalSharing(familyId: number): Promise<boolean> {
    const response = await apiClient.get<boolean>(`${this.baseUrl}/${familyId}/has-active-portal-sharing`);
    return response.data;
  }
}

export const familyService = new FamilyService();